import {
  Highlight,
  Hits,
  InstantSearch,
  Pagination,
  RefinementList,
  Menu,
  HierarchicalMenu ,
  // RangeInput,
  // MenuSelect,
  Configure,
  SearchBox,
  SortBy ,
  // ClearRefinements,
  CurrentRefinements,
} from 'react-instantsearch-hooks-web';
import { history } from 'instantsearch.js/es/lib/routers';
import { simple } from 'instantsearch.js/es/lib/stateMappings';
import algoliasearch from 'algoliasearch/lite';

import { Panel } from './components/Panel';
// import { Dropdown } from './components/Dropdown';
import { Stats } from './components/Stats';
// import {CustomRangeInput} from './components/CustomRangeInput';
import {CustomRangeSlider} from './components/RangeSlider';
// import {DateRangePicker, DateRangePickerComponent} from './components/DateRangePickerComponent';

import {CustomClearRefinements} from './hooks/clearRefine';

import {
  INSTANT_SEARCH_HIERARCHICAL_ATTRIBUTES,
  INSTANT_SEARCH_HIERARCHICAL_PTYPE,
  INSTANT_SEARCH_INDEX_NAME,
} from './constants';


import './App.css';
import React, { useRef, useState, useEffect } from 'react';

const searchClient = algoliasearch(
  '4UZO1Y6OW8',
  'd3f7f97d15ac1f9fceea57943ac7f8e2'
);


const routing = {
  router: history(),
  stateMapping: simple(),
  // stateMapping: singleIndex(INSTANT_SEARCH_INDEX_NAME)
};

//set close options?
const closeOnChange = () => window.innerWidth > 375;

//set program and project status to human readable label
const transformStatus = (items) => {
  // console.log(items);
  return items.map((item) => ({
    ...item,
    label: (item.label === 'a') ? "Active" : "Inactive",
  }));
};
const transformDate = (items) => {
  // console.log('date', items);
  // return items.map((item) => ({
  //   ...item,
  //   label: (item.label === 'a') ? "Active" : "Inactive",
  // }));
};
function facetHeader(label){
  return (
    <h5 className="facetLabel">
      {label}
    </h5>
  );
}

function getDomain(){
  let currentURL =  window.location.hostname;
  let did = 0;
  // console.log('current url', currentURL);
  switch(currentURL){
    case 'fri2022.dev.keencreative.com':
    case 'fri2022.dev.friresearch.ca':
    case 'friresearch.ca':
    case 'localhost':
      did = "1";
      break;
    case 'landusekn.ca':
    case 'landusekn.dev.keencreative.com':
      did = "2";
      break;
    case 'fgrow.ca':
    case 'fgrow.dev.keencreative.com':
      did = "3";
      break;
    case 'flmf.ca':
    case 'flmf.dev.keencreative.com':
      did = "4";
      break;
    case 'fscp.ca':
    case 'fscp.dev.keencreative.com':
      did = "5";
      break;
    case 'arckp.ca':
    case 'arckp.dev.keencreative.com':
      did = "6";
      break;
    default:
      did = "0";
      break;
  }

  return did;

}

function setDomainFilter(){
  let domainid = getDomain();
  // console.log('domain: ',domainid);
  if(domainid == 0){
    return "";
  }
  return "domain:"+domainid;
}

function App() {

  
  const [currentSearch, setSearch] = React.useState(false);  
  const url = window.location.href;

  function checkUrl(){
    let currenturl = window.location.href;
    // console.log('searching', window.location.href);
    if ( currenturl.indexOf('?') !== -1) {
      setSearch(true);
      return true;
    }
    else{
      setSearch(false);
    }
    return false;
  }
  // console.log('check loc',url);
  useEffect(() => {
    
    let currenturl = window.location.href;
    // console.log('searching', window.location.href);
    if ( currenturl.indexOf('?') !== -1) {
      setSearch(true);
    }
    else{
      setSearch(false);
    }
  },[url]);
  
  return (
    <div className="search-controller">
      <InstantSearch
        searchClient={searchClient}
        indexName={INSTANT_SEARCH_INDEX_NAME}
        routing={routing}
      >
      <Configure
        filters= {setDomainFilter()}
      />
      <div className="search-header">
        <div className="container">
          <h2 className="heading">Search Our Knowledge Base</h2>
        <SearchBox className="searchbox" placeholder="Search..." />
        </div>
      </div>
      <div className="search-wrap">
        
        <div className="container">
        <div className="search-meta">
          <Stats 
                translations={{
                  stats(nbHits) {
                    return `Results (${nbHits.toLocaleString()})`;
                  },
                }} 
              />
          <div className="sortcontainer">
            <span className="slabel">Sort By</span>
          <SortBy className="sorter"
            items={[
              { label: 'Newest First', value: 'frisearchable_posts' },
              { label: 'Oldest First', value: 'date_asc' },
              // { label: 'Name', value: 'post_title_asc' },
            ]}
          />
          </div>
              
        </div>
        <div className="search-panel">
          <div className="search-panel__filters">
              
          {/* <ClearRefinements
            translations={{
              resetButtonText: 'Clear all',
            }}
          /> */}
          <CurrentRefinements excludedAttributes={['post_type_label', 'post_date']} />
          <CustomClearRefinements />
          <div className="mobile-only filtertoggle" >
            <div>Filters</div><i className="fa fa-plus"></i>
          </div>
          <div className="filter-collapse">

          {/* <RangeInput attribute="post_date" /> */}
          {/* <CustomRangeInput attribute="post_date" /> */}
          <Panel header={facetHeader("Date Range")} >
          {/* <DateRangePickerComponent attribute="post_date" /> */}
          <CustomRangeSlider attribute="post_date" />
          </Panel>
          {/* <CustomRangeSlider attribute="post_date" /> */}
            
            
          

            {/* <MenuSelect
                  attribute="related_program"
                  limit={100}
            />
            <MenuSelect
              attribute="related_project"
              limit={100}
            /> */}
            {/* <Panel 
              header={facetHeader("Program/Project Status")}
            >
              <RefinementList 
                attribute="active_status" 
                transformItems={transformStatus}
                />

            </Panel> */}
            <Panel 
              header={facetHeader("Subject")}
              panelid="subject"
              iscollapse="collapse"
            >
              <HierarchicalMenu 
                attributes={INSTANT_SEARCH_HIERARCHICAL_ATTRIBUTES} 
                // showMore={true}
                showParentLevel={true}
                limit={100}
                showMoreLimit={150}
              />
            </Panel>
            <Panel 
              header={facetHeader("News Type")}
              panelid="news"
              iscollapse="collapse"
            >
              <Menu 
                    attribute="taxonomies.category"  
              />

            </Panel>
            <Panel 
              header={facetHeader("Publication Type")}
              panelid="pub"
              iscollapse="collapse"
            >
              <HierarchicalMenu 
                attributes={INSTANT_SEARCH_HIERARCHICAL_PTYPE} 
                // showMore={true}
                showParentLevel={true}
                limit={100}
                showMoreLimit={150}
              />

            </Panel>
            <Panel 
              header={facetHeader("Programs")}
              panelid="program"
              iscollapse="collapse"
            >
            <RefinementList
                attribute="related_program"
                searchable={true}
                searchablePlaceholder="Program Name..."
                // limit={100}
                
                limit={10}
                showMore={true}
                showMoreLimit={50}
              />
              </Panel>
            <Panel 
              header={facetHeader("Projects")}
              panelid="projects"
              iscollapse="collapse"
            >
            {/* <Dropdown 
              closeOnChange={closeOnChange}
              buttonText="Click to select"
            >
              
            </Dropdown> */}
            <RefinementList
                attribute="related_project"
                searchable={true}
                searchablePlaceholder="Project Name..."
                
                limit={10}
                showMore={true}
                showMoreLimit={50}
              />

              </Panel>
              <Panel 
                header={facetHeader("Type")}
                panelid="type"
                iscollapse="collapse"
                className="post_type_filter hidefilter"
              >
                <Menu 
                      attribute="post_type_label"  
                />

              </Panel>
              {/* <Panel 
                header={facetHeader("Domain")}
                panelid="type"
                iscollapse="collapse"
                className="domain_filter hidefilter"
              >
                <Menu 
                      attribute="domain"  
                />

              </Panel> */}
              
            </div>
          </div>

          <div className="search-panel__results">
            <div className={"checksearch " + (currentSearch ? '' : 'nosearch')}>

            <Configure hitsPerPage={20} />
            <Hits hitComponent={Hit} />
            <div className="pagination">
              <Pagination />
            </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      </InstantSearch>
    </div>
  );
}

function imageOutput(props){
  // console.log('data',props.images);
  // console.log('image length',props.images);
  // console.log('check image');
  var resultlink = _fsearch_buildDomainURL(props.post_name, props.post_type);
  if(props.hasOwnProperty('images') 
    && props.images.hasOwnProperty('thumbnail')
    ){
    // console.log('found images')
    let imageobj = props.images;
    // console.log('image obj: ', imageobj);
    if(imageobj){
      let imgobj = imageobj.thumbnail;
      // console.log('image obj: ', imgobj);
      let imgalt = props.post_title;
      let imgurl = imgobj.url;

      return (
        <div className="imgcontainer">
          <a href={resultlink}>
            <div className="wrap">
            <img src={imgurl} alt={imgalt} />
            </div>
          </a>
        </div>
      );
    }
  }
  
  if(props.hasOwnProperty('image_override')){
    // console.log('found override image');
    let imgurl = props.image_override;
    // console.log('image_override',props.image_override);
    if(imgurl){
      let imgalt = props.post_title;
      return (
        <div className="imgcontainer">
        <a href={resultlink}>
          <div className="wrap">
            <img src={imgurl} alt={imgalt} />
          </div>
        </a>
        </div>
    );
    }
  }
  return (<div className="imgcontainer"><a href={resultlink}><div className="wrap"></div></a></div>);
};


function kcformatDate(timestamp){
  const date = new Date(timestamp * 1000);
  return `${date.getFullYear()}-${date.getMonth() < 9 ? '0' : ''}${
    date.getMonth() + 1
  }-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
};

function kcformatDate_display(timestamp){
  const date = new Date(timestamp * 1000);
  const options = { year: "numeric", month: "long", day: "numeric" }

  return date.toLocaleDateString(undefined, options);
};

function relabelPosts(posttype){
  var newlabel = posttype;
  if(posttype == 'post'){
    newlabel = 'News';
  }

  return newlabel;
};
function showPostTypes(posttype){
  var newlabel = '';
  if(posttype == 'projects' || posttype == 'project'){
    newlabel = 'Project';
  }

  return newlabel;
};

function createResultClass(classString){
  var makestring = classString.toString();
  var defaultClasses = 'ar ';
  return defaultClasses + makestring;

}

function _fsearch_buildList(data, containerClass){

  // console.log('thedata', data);
  let list = '';
  // console.log('list format',data);
  if(data){
    list = data.map(t => <span>{t}</span>).reduce((accu, elem) => {
        return accu === null ? [elem] : [...accu, ' ', elem]
    }, null)
  }
  else{
    return "";
  }

  let classString = "taglist " + containerClass;

  return (
    <div className={classString}>
      {list}
    </div>
  );

}

function _fsearch_buildDomainURL(slug, type){

  var domain = window.location.origin;
  var fulllink = domain;

  if(type){
    // console.log('type',type);
    let typeurl = '';
    switch(type){
      case "program":
      case "programs":
        typeurl = '/program';
        break;
      case "project":
      case "projects":
        typeurl = '/project';
        break;
      case "posts":
      case "post":
        typeurl = '/news';
        break;
      case "resources":
      case "publications":
        typeurl = '/publications';
        break;

    }
    fulllink += typeurl;
  }

  if(slug){
    fulllink += '/'+slug;
  }
  
  return fulllink;

}

function Hit({ hit }) {
  // console.log(hit);
  return (
    <article className={createResultClass(hit.post_type)} id={"pid-"+hit.post_id} key={"p-"+hit.post_id} >
      <div className="imgmeta">
        {imageOutput(hit)}
        <div className="post_type">
          {showPostTypes(hit.post_type)}
        </div>
        <div className="type">
          {_fsearch_buildList(hit.taxonomies.publication_type,'publication')}
          {_fsearch_buildList(hit.taxonomies.category,'news')}
        </div>
      </div>
      <div className="text-container">
        <div className="date">{kcformatDate_display(hit.post_date)}</div>
        <h1 className="atitle">
        <a href={_fsearch_buildDomainURL(hit.post_name, hit.post_type)}>
          <Highlight attribute="post_title" hit={hit} />
          </a>
        </h1>
        <div className="tags">
          <Highlight className="author" attribute="author" hit={hit}></Highlight>
          
          {/* <div className="program">
            {hit.related_program}
          </div> */}
        </div>
        <p className="description">
          <Highlight attribute="post_excerpt" hit={hit} />
        </p>
      </div>
      
    </article>
  );
}

export default App;
